module.exports = "<div *ngIf=\"legacyHtmlWidget\"\n    #legacyHtmlWidgetContainer\n    [innerHTML]=\"legacyHtmlWidget.html\"\n></div>"